module.exports = __webpack_public_path__ + "img/check-icon.4ee18c5e.svg";